import React from "react";
import PropTypes from "prop-types";

import { Sidebar as SidebarComponent } from "semantic-ui-react";

import "./Sidebar.css";

import { Chevron, Tab } from "./components";

export function Sidebar({ title, tab, slideAway, children, ...callbacks }) {
  const [visible, setVisible] = React.useState(false);
  const [hidden, setHidden] = React.useState(true);

  React.useEffect(() => {
    if (slideAway && visible) setVisible(false);
  }, [slideAway, visible]);

  return (
    <div data-test="sidebar">
      <Tab
        title={title}
        icon={<Chevron pointRight={visible} />}
        visible={hidden}
        slideOut={slideAway}
        onClick={() => {
          setVisible(true);
        }}
      >
        {tab}
      </Tab>
      <SidebarComponent
        animation="overlay"
        className={`hub-feed-sidebar${slideAway ? " slide-away" : ""}`}
        direction="right"
        width="wide"
        style={{ backgroundColor: "white", top: "47px" }}
        visible={visible}
        onShow={() => {
          callbacks.onOpened();
        }}
        onVisible={() => {
          callbacks.onOpening();
          setHidden(false);
        }}
        onHidden={() => {
          setHidden(true);
          callbacks.onClosed();
        }}
      >
        {children}

        <Tab
          open
          title={title}
          icon={<Chevron pointRight={visible} />}
          visible={!hidden}
          onClick={() => {
            setVisible(false);
          }}
        >
          {tab}
        </Tab>
      </SidebarComponent>
    </div>
  );
}

Sidebar.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  tab: PropTypes.node,
  slideAway: PropTypes.bool,
  onOpening: PropTypes.func,
  onOpened: PropTypes.func,
  onClosed: PropTypes.func,
};

Sidebar.defaultProps = {
  title: "",
  children: null,
  tab: null,
  slideAway: false,
  onOpening: () => {},
  onOpened: () => {},
  onClosed: () => {},
};

export default Sidebar;
